import React from 'react'
import ValidLineItem from './ValidLineItem'
import InvalidLineItem from './InvalidLineItem'
import ScannedLineItem from './ScannedLineItem'

const SCAN_VALID = 'scan_valid'
const SCANNED_BEFORE = 'scanned_before'
const SCAN_INVALID = 'scan_invalid'

const ScanLineItem = (props) => {

    const {scan} = props

    return (
        <>
            {scan.status === SCAN_VALID &&
                <ValidLineItem scan={scan}/>
            }

            {scan.status === SCANNED_BEFORE &&
                <ScannedLineItem scan={scan}/>
            }

            {scan.status === SCAN_INVALID &&
                <InvalidLineItem scan={scan}/>
            }
        </>
    )

}

export default ScanLineItem
